import { AxiosError } from 'axios';
import { useEffect, useMemo, useRef, useState } from 'react';
import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { postSellTractorSurveyDataToSpreadSheet } from '../../../../api/sheet/postSellTractorSurveyDataToSpreadSheet';
import { ITractorImage } from '../../../../api/user/mutations/postUsersSellTractors';
import { ImageUploadButton } from '../../../../components/common/buttons/ImageUploadButton';
import { TelInput } from '../../../../components/common/inputs/TelInput';
import { PopupConfirmModal } from '../../../../components/common/modal/popup/PopupConfirmModal';
import { SlideConfirmModal } from '../../../../components/common/modal/slide/SlideConfirmModal';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { flarelaneEventKeys } from '../../../../constants/flarelaneEvent/flarelaneEvent.contant';
import { OpenMarketProductApprovalStatusConstant } from '../../../../constants/openMarketProduct/openMarketProduct';
import { pageInfo, sellTractorPageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { ProductStatusConstant } from '../../../../constants/product/product.constant';
import { sellTractorSurveySteps } from '../../../../constants/survey/sellTractorSurvey';
import { TEMP_DATA_KEYS } from '../../../../constants/tempData/tempData.contant';
import {
  combineImageUploadButtonConstants,
  tractorImageUploadButtonConstants,
  transplanterImageUploadButtonConstants,
} from '../../../../constants/tractorImageUploadButton/tractorImageUploadButton.constant';
import { usePostBumpUserSellTractorMutation } from '../../../../hooks/api/product/mutations/usePostBumpUserSellTractor.mutation';
import { usePatchUserSellTractorsMutation } from '../../../../hooks/api/user/mutations/usePatchUserSellTractors.mutation';
import { usePostUsersSellTractorsMutation } from '../../../../hooks/api/user/mutations/usePostUsersSellTractors.mutation';
import { usePutUsersMeMutation } from '../../../../hooks/api/user/mutations/usePutUsersMe.mutation';
import { useGetMyOwnTractorImagesById } from '../../../../hooks/api/user/queries/useGetMyOwnTractorImagesById';
import { useCheckCameraPermission } from '../../../../hooks/check/useCheckCameraPermission';
import { usePopup } from '../../../../hooks/popup/usePopup';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { useGetUserProfile } from '../../../../hooks/user/useGetUserProfile';
import { useUserTempData } from '../../../../hooks/userTempData/useUserTempData';
import { MachineType } from '../../../../interfaces/Brand.interfaces';
import { useNotification } from '../../../../provider/ToastNotificationProvider';
import { imageTypes, tractorImageType, userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { createUserSellTractorTempData } from '../../../../utils/creator/createUserSellTractorTempData.util';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';
import { SellTractorSurveyImageExample } from './components/SellTractorSurveyImageExample';

export const SellTractorSurveyTractorRequiredImagePage = () => {
  // TODO: 파라메터 파악을 위해 형식 변경 필요
  const SELL_TRACTOR_IMAGE_CATEGORY = 'sell-tractors';

  const shouldOpenSettings = true;
  useCheckCameraPermission(shouldOpenSettings);
  const navigate = useNavigate();
  const Popup = usePopup();

  const { removeUserTempData } = useUserTempData();

  const { isUserLoggedIn } = useCheckUserLoggedIn();
  const { userProfile } = useGetUserProfile();

  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState<boolean>(false);
  const [isRerequestPopupModalOpen, setIsRerequestPopupModalOpen] = useState<boolean>(false);
  const [isSyetemErrorPopupModalOpen, setIsSyetemErrorPopupModalOpen] = useState<boolean>(false);
  const [isImageUploadFailedModalOpen, setIsImageUploadFailedModalOpen] = useState<boolean>(false);
  const [isNeedJoinModalOpen, setIsNeedJoinModalOpen] = useState<boolean>(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState<boolean>(false);
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState<boolean>(false);
  const [phoneNumberInput, setPhoneNumberInput] = useState<string>('');
  const [phoneNumberError, setPhoneNumberError] = useState<string>('');
  const { getUserTempData, setUserTempData } = useUserTempData();

  const dispatch = useAppDispatch();
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;
  const userSellTractorSurveySelector = useAppSelector((state) => state.userSellTractorSurvey);
  const { mutate: postUsersSellTractor, isLoading: isPostUsersSellTractorLoading } = usePostUsersSellTractorsMutation();
  const { mutate: patchUserSellTractor, isLoading: isPatchUserSellTractorLoading } = usePatchUserSellTractorsMutation();

  const { mutate: postBumpUserSellTractor, isLoading: isPostBumpUserSellTractorLoading } =
    usePostBumpUserSellTractorMutation();

  const { mutate: putUsersMe, isLoading: isPutUsersMeLoading } = usePutUsersMeMutation();

  const phoneNumberInputRef = useRef<HTMLInputElement | null>(null);

  const { data: myOwnTractorImages } = useGetMyOwnTractorImagesById({
    ownTractorId: userSellTractorSurveySelector.userOwnTractorId ?? '',
    options: {
      enabled: !!userSellTractorSurveySelector.userOwnTractorId,
    },
  });

  const isRegistration = !userSellTractorSurveySelector.sellTractorIdForEdit;
  const currentStep = isRegistration ? sellTractorSurveySteps.STEP3 : sellTractorSurveySteps.STEP8;
  const steps = Object.keys(sellTractorSurveySteps);
  const registrationSteps = steps.slice(0, 3);

  const isNewMachine =
    !userSellTractorSurveySelector.sellTractorMachineInfo?.id &&
    !userSellTractorSurveySelector.userOwnTractorId &&
    userSellTractorSurveySelector.model;

  const { openNotification } = useNotification();

  const [isShowExampleImageModal, setIsShowExampleImageModal] = useState<boolean>(false);
  const [isExampleModalShowed, setIsExampleModalShowed] = useState<boolean>(false);

  const representiveImageRef = useRef<HTMLInputElement | null>(null);

  const tractorImages = useMemo<ITractorImage[]>(() => {
    const tractorImages: ITractorImage[] = [];

    imageTypes.forEach((type) => {
      if (userSellTractorSurveySelector.tractorImageUrls[type]) {
        tractorImages.push({ type, url: userSellTractorSurveySelector.tractorImageUrls[type] });
      }
    });

    return tractorImages;
  }, [userSellTractorSurveySelector.tractorImageUrls]);

  const hasRequiredImage = !!userSellTractorSurveySelector.tractorImageUrls.LEFT;

  const handleDeleteImage = (imageType: tractorImageType) => {
    dispatch(
      userSellTractorSurveyActions.changeTractorImageUrls({
        property: imageType,
        imageUrl: '',
      }),
    );
  };

  const handleUploadImage = (imageType: tractorImageType, imageUrl: string) => {
    dispatch(
      userSellTractorSurveyActions.changeTractorImageUrls({
        property: imageType,
        imageUrl,
      }),
    );
  };

  const handleCompleteModalButtonClick = () => {
    dispatch(userSellTractorSurveyActions.resetState());
    setIsCompleteModalOpen(false);
    navigate(`${pageInfo.openMarketListPage.path}`, { replace: true });
  };

  const handleUploadAnotherModalButtonClick = () => {
    dispatch(userSellTractorSurveyActions.resetState());
    setIsCompleteModalOpen(false);
    navigate(`${pageInfo.sellTractorEntryPage.path}`, { replace: true });
  };

  const updateUserSellTractor = () => {
    const { machineType } = userSellTractorSurveySelector;
    const baseReqBody = {
      manufacturedYear: Number(userSellTractorSurveySelector.manufacturedYear),
      operationTime: Number(userSellTractorSurveySelector.operationTime),
      option: userSellTractorSurveySelector.option ?? null,
      optionDetails: userSellTractorSurveySelector.optionDetails ?? null,
      workingMachine: userSellTractorSurveySelector.workingMachine ?? null,
      workingMachineDetails: userSellTractorSurveySelector.workingMachineDetails ?? null,
      hopeSellingPrice: userSellTractorSurveySelector.hopeSellingPrice! * 10000,
      tractorImages,
      location: userSellTractorSurveySelector.location!,
      directImportYn: userSellTractorSurveySelector.directImportYn ?? null,
      priceNegotiationYn: userSellTractorSurveySelector.priceNegotiationYn ?? null,
      needRepairParts: userSellTractorSurveySelector.needRepairParts ?? null,
      replacedParts: userSellTractorSurveySelector.replacedParts ?? null,
      information: userSellTractorSurveySelector.information!,
      approvalStatus: OpenMarketProductApprovalStatusConstant.APPROVAL,
      status: ProductStatusConstant.ONSALE,
    };

    const wheelConditions =
      machineType === 'transplanter'
        ? {
            frontWheelCondition: userSellTractorSurveySelector.frontWheelCondition ?? null,
            rearWheelCondition: userSellTractorSurveySelector.rearWheelCondition ?? null,
          }
        : machineType === 'combine'
          ? {
              leftTrackCondition: userSellTractorSurveySelector.leftTrackCondition ?? null,
              rightTrackCondition: userSellTractorSurveySelector.rightTrackCondition ?? null,
            }
          : {
              frontTireCondition: userSellTractorSurveySelector.frontTireCondition ?? null,
              rearTireCondition: userSellTractorSurveySelector.rearTireCondition ?? null,
            };

    patchUserSellTractor(
      {
        sellTractorId: userSellTractorSurveySelector.sellTractorIdForEdit!,
        reqBody: {
          ...baseReqBody,
          ...wheelConditions,
        },
      },
      {
        onSuccess: (data) => {
          ampli.pvmEditSellMachineComplete({
            id: userSellTractorSurveySelector.sellTractorIdForEdit!,
            type: String(userSellTractorSurveySelector.machineType),
          });
          if (isRerequestPopupModalOpen) {
            setIsRerequestPopupModalOpen(false);
          }

          openNotification({ message: '정보 수정이 완료 되었습니다.' });
          navigate(pageInfo.myInfoSellTractorListPage.path, { replace: true });
          setTimeout(() => {
            dispatch(userSellTractorSurveyActions.resetState());
          }, 100);
        },
        onError: (error) => {
          if (error instanceof AxiosError) {
            if (!error.response) {
              setIsRerequestPopupModalOpen(true);
            } else {
              setIsSyetemErrorPopupModalOpen(true);
            }
          }
        },
      },
    );
  };

  const sendSellTractorAnalytics = (isLoggedIn: boolean) => {
    ReactGA.event('pvm_sell_tractor_complete', {
      category: 'pvm',
      action: 'pvm_sell_tractor_complete',
      isLoggedIn,
    });
    ampli.pvmSellTractorComplete({ isLoggedIn, type: userSellTractorSurveySelector.machineType ?? '' });
  };

  const handleSurveySubmit = (options?: { skipPhoneNumberCheck?: boolean }) => {
    if (!hasRequiredImage) {
      setIsShowErrorModal(true);
      return;
    }
    if (!isUserLoggedIn) {
      const { newSellTractorTempData } = createUserSellTractorTempData({
        formData: userSellTractorSurveySelector,
        isUserSubmit: false,
      });

      const { userTempData } = getUserTempData();
      userTempData.set(TEMP_DATA_KEYS.SELL_TRACTOR_SURVEY, newSellTractorTempData);
      setUserTempData({ newTempData: userTempData });
      sendSellTractorAnalytics(isUserLoggedIn);

      setIsNeedJoinModalOpen(true);
      return;
    }

    if (!options?.skipPhoneNumberCheck && !userProfile?.phoneNumber) {
      setIsPhoneNumberModalOpen(true);
      return;
    }

    if (userSellTractorSurveySelector.sellTractorIdForEdit) {
      updateUserSellTractor();
      return;
    }
    const { machineType } = userSellTractorSurveySelector;
    const baseCreateReqBody = {
      userOwnTractorId: userSellTractorSurveySelector.userOwnTractorId ?? null,
      brandId: userSellTractorSurveySelector.brandId!,
      model: userSellTractorSurveySelector.model!,
      machineType: machineType as MachineType,
      rowConfig: userSellTractorSurveySelector.rowConfig!,
      manufacturedYear: Number(userSellTractorSurveySelector.manufacturedYear),
      operationTime: Number(userSellTractorSurveySelector.operationTime),
      option: userSellTractorSurveySelector.option ?? null,
      optionDetails: userSellTractorSurveySelector.optionDetails ?? null,
      workingMachine: userSellTractorSurveySelector.workingMachine ?? null,
      workingMachineDetails: userSellTractorSurveySelector.workingMachineDetails ?? null,
      hopeSellingPrice: userSellTractorSurveySelector.hopeSellingPrice! * 10000,
      tractorImages,
      location: userSellTractorSurveySelector.location!,
      directImportYn: userSellTractorSurveySelector.directImportYn ?? null,
      priceNegotiationYn: true,
      needRepairParts: userSellTractorSurveySelector.needRepairParts ?? null,
      replacedParts: userSellTractorSurveySelector.replacedParts ?? null,
      information: userSellTractorSurveySelector.information!,
    };

    const engineAndWheelConditions =
      machineType === 'tractor'
        ? {
            engineOutputInPs: Number(userSellTractorSurveySelector.engineOutputInPs),
            frontTireCondition: userSellTractorSurveySelector.frontTireCondition ?? null,
            rearTireCondition: userSellTractorSurveySelector.rearTireCondition ?? null,
            leftTrackCondition: null,
            rightTrackCondition: null,
            frontWheelCondition: null,
            rearWheelCondition: null,
          }
        : machineType === 'combine'
          ? {
              engineOutputInPs: Number(userSellTractorSurveySelector.engineOutputInPs),
              frontTireCondition: null,
              rearTireCondition: null,
              leftTrackCondition: userSellTractorSurveySelector.leftTrackCondition ?? null,
              rightTrackCondition: userSellTractorSurveySelector.rightTrackCondition ?? null,
              frontWheelCondition: null,
              rearWheelCondition: null,
            }
          : {
              engineOutputInPs: 0,
              frontTireCondition: null,
              rearTireCondition: null,
              leftTrackCondition: null,
              rightTrackCondition: null,
              frontWheelCondition: userSellTractorSurveySelector.frontWheelCondition ?? null,
              rearWheelCondition: userSellTractorSurveySelector.rearWheelCondition ?? null,
            };

    postUsersSellTractor(
      {
        reqBody: {
          ...baseCreateReqBody,
          ...engineAndWheelConditions,
        },
      },
      {
        onSuccess: (data) => {
          removeUserTempData({ dataKey: 'SELL_TRACTOR_SURVEY' });

          if (userProfile) {
            postSellTractorSurveyDataToSpreadSheet({
              userId: userProfile.id,
              userName: userProfile.name,
              userPhoneNumber: userProfile.phoneNumber,
              completed: true,
            });
          }

          if (isRerequestPopupModalOpen) {
            setIsRerequestPopupModalOpen(false);
          }

          if (window.ReactNativeWebView) {
            postMessageToRN({
              messageKey: 'flarelane_trackEvent',
              messageParam: isNewMachine
                ? flarelaneEventKeys.pvm_sell_tractor_complete_with_new_machine
                : flarelaneEventKeys.pvm_sell_tractor_complete,
            });
          }

          setIsCompleteModalOpen(true);
          sendSellTractorAnalytics(isUserLoggedIn);
        },
        onError: (error) => {
          if (error instanceof AxiosError) {
            if (!error.response) {
              setIsRerequestPopupModalOpen(true);
            } else {
              setIsSyetemErrorPopupModalOpen(true);
            }
          }
        },
      },
    );
  };

  const handleImageExampleModalTriggerClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!isExampleModalShowed) {
      setIsShowExampleImageModal(true);
      setIsExampleModalShowed(true);
      e.preventDefault();
    }
  };

  const handleImageUploadError = () => setIsImageUploadFailedModalOpen(true);

  const validatePhoneNumberWithoutHyphen = (phoneNumber: string): boolean => {
    const phoneNumberRegex = /^01[0-9]{9}$/;
    return phoneNumberRegex.test(phoneNumber);
  };

  const handlePhoneNumberSubmit = () => {
    if (!validatePhoneNumberWithoutHyphen(phoneNumberInput)) {
      setPhoneNumberError('올바른 번호를 입력해주세요');
      return;
    }

    putUsersMe(
      {
        reqBody: {
          phoneNumber: phoneNumberInput,
        },
      },
      {
        onSuccess: () => {
          setIsPhoneNumberModalOpen(false);
          setPhoneNumberInput('');
          setPhoneNumberError('');
          handleSurveySubmit({ skipPhoneNumberCheck: true });
        },
        onError: () => {
          setPhoneNumberError('전화번호 업데이트에 실패했습니다.');
        },
      },
    );
  };

  useEffect(() => {
    const continueWithOwnTractorImages = () => {
      if (!myOwnTractorImages) {
        return;
      }

      const formattedOwnTractorImages = myOwnTractorImages.map((image) => {
        return {
          property: image.type,
          imageUrl: image.url,
        };
      });

      formattedOwnTractorImages.forEach((image) => {
        dispatch(userSellTractorSurveyActions.changeTractorImageUrls(image));
      });
    };

    if (myOwnTractorImages && myOwnTractorImages.length > 0) {
      continueWithOwnTractorImages();
    }
  }, [myOwnTractorImages, dispatch, userSellTractorSurveyActions]);

  const machineImageUploadButtonConstants = useMemo(() => {
    const { machineType } = userSellTractorSurveySelector;
    if (machineType === 'combine') {
      return combineImageUploadButtonConstants;
    }
    if (machineType === 'transplanter') {
      return transplanterImageUploadButtonConstants;
    }
    return tractorImageUploadButtonConstants;
  }, [userSellTractorSurveySelector.machineType]);

  return (
    <>
      <SellTractorSurveyPageWrapper
        headerTitle={'매물 사진을 등록해주세요'}
        isLoading={isPostUsersSellTractorLoading}
        canConfirm
        confirmButtonText={'완료'}
        confirmHandler={handleSurveySubmit}
        prevButtonHandler={() => navigate(sellTractorPageInfo.pricePage.path, { replace: true })}
        steps={isRegistration ? registrationSteps : steps}
        currentStep={currentStep}
      >
        <SurveyForm id={'survey_page_wrapper'}>
          <ContentsContainer>
            <SurveyInputHeader inputTitle={'매물 필수 사진 (대표 사진 필수)'} isRequired />

            <ImageUploadSection>
              <ImageExampleModalTrigger onClick={handleImageExampleModalTriggerClick}>
                {machineImageUploadButtonConstants
                  .filter((imageUploadButton) => imageUploadButton.type === 'LEFT')
                  .map((imageUploadButton) => (
                    <ImageUploadButton
                      key={imageUploadButton.id}
                      inputId={imageUploadButton.id}
                      buttonText={imageUploadButton.buttonText}
                      uploadedImageUrl={userSellTractorSurveySelector.tractorImageUrls[imageUploadButton.type]}
                      successHandler={(imageUrl: string) => handleUploadImage(imageUploadButton.type, imageUrl)}
                      errorHandler={handleImageUploadError}
                      deleteHandler={() => handleDeleteImage(imageUploadButton.type)}
                      inputRef={representiveImageRef}
                      category={SELL_TRACTOR_IMAGE_CATEGORY}
                    />
                  ))}
              </ImageExampleModalTrigger>
            </ImageUploadSection>
          </ContentsContainer>

          <ContentsContainer>
            <SurveyInputHeader inputTitle={'매물 추가 사진'} isOptional />
            <ImageUploadSection>
              {machineImageUploadButtonConstants
                .filter((imageUploadButton) => imageUploadButton.type !== 'LEFT')
                .map((imageUploadButton) => (
                  <ImageUploadButton
                    key={imageUploadButton.id}
                    inputId={imageUploadButton.id}
                    buttonText={imageUploadButton.buttonText}
                    uploadedImageUrl={userSellTractorSurveySelector.tractorImageUrls[imageUploadButton.type]}
                    successHandler={(imageUrl: string) => handleUploadImage(imageUploadButton.type, imageUrl)}
                    errorHandler={handleImageUploadError}
                    deleteHandler={() => handleDeleteImage(imageUploadButton.type)}
                    category={SELL_TRACTOR_IMAGE_CATEGORY}
                  />
                ))}
            </ImageUploadSection>
          </ContentsContainer>
        </SurveyForm>
      </SellTractorSurveyPageWrapper>

      <PopupConfirmModal
        isShow={isShowErrorModal}
        hasCloseButton={false}
        closeModal={() => setIsShowErrorModal(false)}
        title={'☝🏻 대표사진 1장은 필수!'}
        description={'판매를 위해 최소 1장의 사진을\n등록 해주세요!'}
        buttonArray={[
          {
            text: '확인',
            onClick: () => setIsShowErrorModal(false),
            color: 'blue',
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isCompleteModalOpen}
        hasCloseButton={false}
        title={'등록 완료! 🎉'}
        description={
          isNewMachine
            ? '입력하신 제원을 확인하고 있습니다.\n확인이 끝나면 정상 등록될 예정입니다.'
            : '내 매물을 확인해 보세요!'
        }
        buttonArray={[
          {
            text: '확인',
            onClick: handleCompleteModalButtonClick,
            color: 'blue',
          },
          {
            text: '추가 등록하기',
            onClick: handleUploadAnotherModalButtonClick,
            color: 'gray',
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isRerequestPopupModalOpen}
        hasCloseButton={false}
        closeModal={() => setIsRerequestPopupModalOpen(false)}
        description={'요청 시간이 초과되었어요 🙂\n아래 버튼을 눌러 다시 요청해주세요!'}
        buttonArray={[
          {
            text: '등록 완료 하기',
            onClick: handleSurveySubmit,
            color: 'blue',
            isLoading: isPostUsersSellTractorLoading,
            disabled: isPostUsersSellTractorLoading,
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isSyetemErrorPopupModalOpen}
        hasCloseButton={false}
        closeModal={() => setIsRerequestPopupModalOpen(false)}
        description={'시스템 에러로 등록이 불가능합니다👨🏻‍🔧\n잠시후에 다시 이용해주세요.'}
        buttonArray={[
          {
            text: '홈으로',
            onClick: () => navigate(pageInfo.homePage.path, { replace: true }),
            color: 'blue',
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isImageUploadFailedModalOpen}
        hasCloseButton={false}
        title={'통신이 원활하지 못해요 👨🏻‍🔧'}
        description={'통신 환경이 더 원활한 곳에서\n다시 시도 해주세요'}
        buttonArray={[
          {
            text: '홈으로',
            onClick: () => navigate(pageInfo.homePage.path, { replace: true }),
            color: 'blue',
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isNeedJoinModalOpen}
        hasCloseButton={false}
        title={'회원가입이 필요해요!'}
        description={'입력하신 트랙터를 판매 하시려면\n회원 가입이 필요합니다.'}
        buttonArray={[
          {
            text: '카카오톡으로 간편 로그인하기',
            onClick: () => {
              ampli.pvmClickSellTractorSignup({
                type: String(userSellTractorSurveySelector.machineType),
              });
              ReactGA.event('pvm_click_sell_tractor_signup');
              navigate(pageInfo.loginPage.path, { replace: true });
            },
            color: 'blue',
          },
          {
            text: '닫기',
            onClick: () => {
              ampli.pvmClickSellTractorSignupCancel({
                type: String(userSellTractorSurveySelector.machineType),
              });
              ReactGA.event('pvm_click_sell_tractor_signup_cancel');
              setIsNeedJoinModalOpen(false);
            },
            color: 'gray',
          },
        ]}
      />
      <PopupConfirmModal
        isShow={isPhoneNumberModalOpen}
        hasCloseButton={false}
        closeModal={() => setIsPhoneNumberModalOpen(false)}
        title={'연락처가 없어 등록이 불가해요!'}
        description={'하단에 연락처를 적어\n등록을 완료할 수 있어요!'}
        element={
          <PhoneNumberInputContainer>
            <TelInput
              borderColor={phoneNumberError ? 'var(--Light-Scheme-Color-error-red, #ff4d4f)' : undefined}
              inputValue={phoneNumberInput}
              placeholder={'예) 01012345678'}
              onChange={(value: string | undefined) => {
                setPhoneNumberInput(value ?? '');
                if (phoneNumberError) {
                  setPhoneNumberError('');
                }
              }}
              inputRef={phoneNumberInputRef}
            />
            {phoneNumberError && <PhoneNumberErrorText>{phoneNumberError}</PhoneNumberErrorText>}
          </PhoneNumberInputContainer>
        }
        buttonArray={[
          {
            text: '등록',
            onClick: handlePhoneNumberSubmit,
            color: 'blue',
            isLoading: isPutUsersMeLoading,
            disabled: isPutUsersMeLoading,
          },
          {
            text: '닫기',
            onClick: () => {
              setIsPhoneNumberModalOpen(false);
              setPhoneNumberInput('');
              setPhoneNumberError('');
            },
            color: 'gray',
          },
        ]}
      />
      <SlideConfirmModal
        isShow={isShowExampleImageModal}
        height={553}
        element={<SellTractorSurveyImageExample />}
        confirmButton={{
          handleClick: () => {
            setIsShowExampleImageModal(false);
            representiveImageRef.current?.click();
          },
          text: '확인',
        }}
        closeButton={{
          handleClick: () => setIsShowExampleImageModal(false),
        }}
      />
    </>
  );
};

const ContentsContainer = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px) 24px var(--radius-large, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const ImageUploadSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const ImageExampleModalTrigger = styled.div`
  width: 100%;
`;

const PhoneNumberInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const PhoneNumberDescription = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
`;

const PhoneNumberErrorText = styled.span`
  color: var(--Light-Scheme-Color-primary-red, #ff3049);
  text-align: center;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
